import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-no-data-found',
  standalone: true,
  imports: [],
  templateUrl: './no-data-found.component.html',
  styleUrl: './no-data-found.component.css'
})
export class NoDataFoundComponent {
  env = environment;
  @Input() imageWidth = 50;

}
